import script from "./AssociationPortalLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./AssociationPortalLanding.vue?vue&type=script&setup=true&lang=js"

import "./AssociationPortalLanding.vue?vue&type=style&index=0&id=d31a5386&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d31a5386"]])

export default __exports__